import { useEffect, useState } from "react";
import api from "@/lib/api";

export function TermsContent() {
  const [t, setT] = useState(null);
  useEffect(() => {
    api.get("/terms").then(({ data }) => setT(data)).catch(() => setT(null));
  }, []);
  if (!t) return <p className="text-sm text-muted-foreground">Loading…</p>;
  return (
    <div className="space-y-5" data-testid="terms-content">
      <p className="label-caps text-muted-foreground">
        Version {t.version} · Effective {t.effective_date}
      </p>
      <p className="text-sm leading-relaxed">{t.intro}</p>
      {t.sections.map((s) => (
        <div key={s.title} className="space-y-1.5">
          <h3 className="font-display text-base font-bold">{s.title}</h3>
          {s.body.split("\n\n").map((p, i) => (
            <p key={`${s.title}-${i}`} className="text-sm leading-relaxed text-muted-foreground">{p}</p>
          ))}
        </div>
      ))}
    </div>
  );
}
